import * as React from "react";

function SvgAlignRightSolid(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path
        d="M2.714 10.571h18.572A.714.714 0 0022 9.857V8.43a.714.714 0 00-.714-.715H2.714A.714.714 0 002 8.43v1.428a.714.714 0 00.714.714zm18.572 8.572H2.714a.714.714 0 00-.714.714v1.429a.714.714 0 00.714.714h18.572a.715.715 0 00.714-.714v-1.429a.714.714 0 00-.714-.714zM21.427 2H9.716a.572.572 0 00-.573.573v1.711a.572.572 0 00.573.573h11.711A.572.572 0 0022 4.284V2.573A.57.57 0 0021.427 2zm0 11.429H9.716a.57.57 0 00-.573.572v1.712a.572.572 0 00.573.573h11.711a.57.57 0 00.573-.573V14a.57.57 0 00-.573-.572z"
        fill="currentColor"
      />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgAlignRightSolid);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
